export default {
  isLoading: false,
  shouldUpdateDataGrid: false,
  listaSolicitudes: [],
  listaSolicitudesFiltrada: [],
  showHideForm: false,
  isOpenModalBorrador: false,
  isOpenModalContinue: false,
  idSelected: null,
  isOpenModalDelete: false,
  isOpenModalEliminarExamenes: false,
  isOpenModalEliminarSolicitud: false,
  examen: {},
  request: {},
  editingDraft: false,
  filtrosSolicitudes: null,
  totalSolicitudes: null,
  selectedTipoSolicitud: {
    Icon: "2", name: "Borrador de solicitud", column: "EstadoDenuncia", value: { text: "borrador", value: 6 } 
  },
  activeStep: 0,
  lastCompletedStep: 1,
  steps: [
    {
      id: 1, text: "Solicitud de exámenes", subtext: "Ingresa la información del aprobador y la solicitud de exámenes.",
    },
    {
      id: 2, text: "Ingreso trabajadores", subtext: "Ingresa el número de trabajadores y los datos de cada uno.",
    },
    {
      id: 3, text: "Confirmación", subtext: "Aquí puedes confirmar toda la información",
    },
  ],
  isModified: false,
  dataTrabajador: {},
  disableContinueNewComplaint: false,
  pendingComplaints: [],
  jsonData: {
    Id: null,
    formSolicitudExamen: {},
    formInfoDenuncia: {},
    formInfoTrabajador: {},
    formDatoSiniestro: {},
    formDatosEmpresa: {},
    formDenunciante: {},
    formDatosEnfermedad: {},
    currentStep: 1,
  },
  listaEmpleados: [{
    nombreEmpleado: "",
    rutEmpleado: "",
    edadEmpleado: 0,
    celularEmpleado: "",
    emailEmpleado: "",
    tipoDocumento: "",
    tipoDocumentoDescripcion: ""
  }],
  listaSolicitantes: [],
  listaCargos: [],
  listaBaterias: [],
  listaExamenes: [],
  listaExamenesPsicologicos: [],
  listaTipoExamenes: [],
  listaCentros: [],
  centroSeleccionado: null,
  tiempoSinNombre: "48",
  openModalButtonNuevaSolicitud: false,
  examenesPsicologicos: false,
  examenesAdicionales: false,
  defaultCityId: null,
  isWorkersUpdate: false,
  isPoolsUpdate: false,
  isExamsUpdate: false,
  isEditTrabajadores: false,
  isRequestHeaderUpdate: false,
  formatoListaEmpleados: [],
  editarBorrador: false,
  isLoadFromInput: false,
  dataSolicitudAgendaSel: {
    idSolicitud: null,
    solicitante: null,
    nombreAprobador: null,
    centroCostos: null,
    cargo: null,
    otroCargo: null,
    tipoEvaluacion: null,
    baterias: [],
    fechaReferencia: null,
    fechaReferenciaEnd: null,
    examenesAdicionales: [],
    examenesPsicologicos: [],
    observaciones: null,
    listaEmpleados: [],
  },
  selectedSolicitudShow: null,
  tipoDocumentos: [
    { Id: 1, Tipo: "Rut" },
    { Id: 2, Tipo: "Pasaporte" },
    { Id: 3, Tipo: "Otro" }
  ]
};
